import { useEffect, useState } from "react";
import { Contact } from "../models/contact.ts"
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useStandardContact = () => {
  const [option, setOption] = useState<Contact>();
  const { handle } = useMessageHandler();

  useEffect(() => {
    handle(async () => {
      const response = await apiJson.get("/mechanics/standard_contact");
      setOption(response.data);
    });
  }, []);

  return { option };
};